document.addEventListener("DOMContentLoaded", () => {
  initNewsletterForms(document);
});

function initNewsletterForms(root) {
  const newsletterForms = root.querySelectorAll('form[is="newsletter-form"]');

  newsletterForms.forEach((form) => {
    const nameInput = form.querySelector("input[name='contact[name]']");
    const emailInput = form.querySelector("input[name='contact[email]']");
    const sentMsg = form.closest('.newsletter-form')?.querySelector('.newsletter-sent');

    const wrapper = form.closest('.newsletter-form');
    if (!wrapper) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (typeof SR !== 'undefined' && SR) {
        const data = {
          name: nameInput?.value.trim() || '',
          email: emailInput?.value.trim() || '',
        };

        SR.event.sendFormData("newsletter-agreement", {
          name: data.name,
          email: data.email,
          newsletter_agreement_enabled: "enabled"
        });
      }

      const height = wrapper.offsetHeight;
      wrapper.style.height = height + "px";
      wrapper.style.transition = "height 0.5s ease";

      form.style.transition = "opacity 0.5s ease";
      form.style.opacity = "0";

      setTimeout(() => {
        form.style.visibility = "hidden";
      }, 500);

      sentMsg.style.display = "flex";
      sentMsg.style.alignItems = "center";
      sentMsg.style.justifyContent = "center";
      sentMsg.style.background = "#51e08a";
      sentMsg.style.padding = "10px 20px";
      sentMsg.style.opacity = "0";
      sentMsg.style.transition = "opacity 0.5s ease";

      setTimeout(() => {
        sentMsg.style.opacity = "1";
      }, 490);
    });
  });
}
